import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
// import profile_img from '../../assets/images/profile_img.png';
// import { toast } from 'react-toastify';
import { LogoutApiDelToken } from '../../Redux/Auth/Auth_Action';

const ProfileTab = (props) => {

    const dispatch = useDispatch();
    let navigate = useNavigate();
    const token = useSelector((state) => state.Auth.token)
    const reduxState = useSelector((state) => state.Auth.user);
    const [selectedImage, setSelectedImage] = useState(null);

    // console.log("prof image",reduxState)

    // const UploadImage = (event) => {
    //     if ((event.target.files[0].size / 1000000) <= 5) {
    //         setSelectedImage(event.target.files[0]);
    //         // props.updateImage({...updateProfile , prof_img : event.target.files[0] })
    //         // console.log('sucess', (event.target.files[0].size / 1000000))
    //     } else {
    //         toast.error("file size is greater than 5 mb");
    //     }
    // }

    // console.log(props)

    const Logout = () => {
        dispatch({
            type: "DEL_TOKEN"
        })
        dispatch(LogoutApiDelToken(token))
            .then((res) => {
                navigate("/signin");
                // console.log("sucessfull logout");
            })
            .catch((e) => {
                navigate("/signin");
                console.log("unsucessfull logout");
            })
    }

    let pathname = window.location.pathname;

    // console.log("del from profile tabs", props.updateImage);

    return (
        <div className='profile'>
            <div className='pink_div '>
                <div
                    style={{ backgroundImage: `url("${reduxState?.profile_picture}")` }}
                    // style={{ backgroundImage: `url(${(!selectedImage) ? profile_img : URL.createObjectURL(selectedImage)})` }} 
                    className='bg-prof-img pos-rel'>
                    {/* <div className='change_profile f-mon-reg'> */}
                        {/* <label htmlFor="fileUpload">
                            <div>
                                <p className='hvr_p'>Change Image</p>
                            </div>
                        </label>
                        <input onChange={UploadImage} hidden id="fileUpload" type="file" accept="image/*" /> */}
                    {/* </div> */}
                </div>
                <p className='f-mon-bold f-25 mt-2 mb-4'>
                    {`${reduxState.first_name} ${reduxState?.last_name}`}
                </p>
                <p onClick={() => { navigate('/profile') }}
                    // f-mon-semibold f-20 clr-white-light my-3 cursor_pointer maaaaaaz
                    className={`${(pathname === "/editprofile" || pathname === "/profile") ? "f-mon-semibold f-20 clr-white-light my-3 cursor_pointer activ_link_prof" : " f-mon-semibold f-20 clr-white-light my-3 cursor_pointer"}`}>Account</p>
                <div className='border-bottom-white-light'></div>
                {/* <p onClick={() => { navigate('/myinterests') }}
                    // f-mon-semibold f-20 clr-white-light my-3 cursor_pointer maaaaaaz
                    className={`${(pathname === "/myinterests") ? "f-mon-semibold f-20 clr-white-light my-3 cursor_pointer activ_link_prof" : " f-mon-semibold f-20 clr-white-light my-3 cursor_pointer"}`}>My Interests</p> */}
                <div className='border-bottom-white-light'></div>
                <p onClick={() => { navigate('/subscription') }}
                    className={`${(pathname === "/subscription") ? "f-mon-semibold f-20 clr-white-light my-3 cursor_pointer activ_link_prof" : " f-mon-semibold f-20 clr-white-light my-3 cursor_pointer"}`}>My Subscription</p>
                <div className='border-bottom-white-light'></div>
                {/* <p onClick={() => { navigate('/packages') }}
                    className={`${(pathname === "/payment") ? "f-mon-semibold f-20 clr-white-light my-3 cursor_pointer activ_link_prof" : " f-mon-semibold f-20 clr-white-light my-3 cursor_pointer"}`}>Packages</p>
                <div className='border-bottom-white-light'></div> */}
                <p onClick={Logout}
                    className={`${(pathname === "/") ? "f-mon-semibold f-20 clr-white-light my-3 cursor_pointer activ_link_prof" : " f-mon-semibold f-20 clr-white-light my-3 cursor_pointer"}`}>Logout</p>
            </div>
        </div>
    )
}

export default ProfileTab;